import { render, staticRenderFns } from "./TileGridSection.vue?vue&type=template&id=1cd0912a&scoped=true"
import script from "./TileGridSection.vue?vue&type=script&setup=true&lang=ts"
export * from "./TileGridSection.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./TileGridSection.vue?vue&type=style&index=0&id=1cd0912a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cd0912a",
  null
  
)

export default component.exports